import { render, staticRenderFns } from "./AppStoreApp.vue?vue&type=template&id=51390a1a&scoped=true&"
import script from "./AppStoreApp.vue?vue&type=script&lang=js&"
export * from "./AppStoreApp.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreApp.vue?vue&type=style&index=0&id=51390a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51390a1a",
  null
  
)

export default component.exports